import { GeneratedAttachmentResponse } from "@/Common/Api/Attachments/Dto/Responses/GeneratedAttachmentResponse";

class DocumentImportInfo {
    public responsibleClinicianContactIds: string[];
    public classLookupId: string;
    public subClassLookupId: string;
    public source: string;
    public description: string;
    public documentDate: Date;
    public note: string;
    public siteId: string;
    public patientContactId: string;
    public generatedAttachment: GeneratedAttachmentResponse;

    constructor(item?: Partial<DocumentImportInfo>) {
        if (item)
            Object.assign(this, item);
    }
}

export { DocumentImportInfo };
